import React from 'react';
import { Search, X } from 'lucide-react';
import './GlobalSearch.css';

export default function GlobalSearch({ value, onChange, resultsCount }) {
  return (
    <div className="global-search">
      <div className="global-search__input-wrapper">
        <Search className="global-search__icon" />
        <input
          type="text"
          placeholder="🔍 Buscar em todos os campos (nome, autor, beneficiário, valor, descrição...)"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="global-search__input"
        />
        {value && (
          <button
            onClick={() => onChange('')}
            className="global-search__clear"
            aria-label="Limpar busca"
          >
            <X className="w-5 h-5" />
          </button>
        )}
      </div>
      
      {value && (
        <p className="global-search__results">
          {resultsCount} resultado{resultsCount !== 1 ? 's' : ''} encontrado{resultsCount !== 1 ? 's' : ''} para "{value}"
        </p>
      )}
    </div>
  );
}
